var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('SpinnerWrapper',[_c('Spinner')],1)],1):_vm._e(),_vm._l((_vm.faqs),function(faq,i){return _c('div',[_c('FAQCard',{attrs:{"id":faq.id,"question":faq.question,"answer":faq.answer,"open":faq.open},on:{"click":function($event){return _vm.navToFAQ(faq)},"nav":_vm.navigate}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }